export function logRequest(url, method, allHeaders = {}, body = undefined, alias = '') {
  console.log('Request:', alias, url.toString(), method, allHeaders, body);
}

export default logRequest;
